import { createSchema, Yup } from '@src/corelib/validation';


/**
 * Profile form schemas (T11). The profile fields (name/email) are all optional
 * strings — the original page never client-validated them, leaving enforcement
 * to the server (which still maps 400 field errors back onto the inputs via the
 * Form's `showServerErrors`). The password form keeps the original client-side
 * "passwords match" check as a yup `.oneOf` so the same inline error surfaces.
 */

/** Profile details (name + email). */
const profileSchema = createSchema({
  first_name: Yup.string(),
  last_name: Yup.string(),
  email: Yup.string(),
});


/** Map the loaded user record onto the form's string-valued shape. */
function profileDefaults(me) {
  return {
    first_name: me?.first_name || '',
    last_name: me?.last_name || '',
    email: me?.email || '',
  };
}


/** Change-password form. Fields stay optional (the original gated the submit
 * button on all three being filled rather than validating required), so the
 * only validation is the confirm field matching `new_password` — preserving the
 * original inline "Passwords do not match." behavior. */
const passwordSchema = createSchema({
  current_password: Yup.string(),
  new_password: Yup.string(),
  re_new_password: Yup.string()
    .oneOf([Yup.ref('new_password')], 'Passwords do not match.'),
});


const passwordDefaults = { current_password: '', new_password: '', re_new_password: '' };


export {
  passwordDefaults,
  passwordSchema,
  profileDefaults,
  profileSchema,
};
